
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["iconify iconify--uil",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","width":"32","height":"32","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M17 6h-2V4h2a1 1 0 000-2H9a5 5 0 00-5 5v14a1 1 0 002 0V7a3 3 0 013-3h4v2h-2a3 3 0 00-3 3v4.93a3 3 0 001.34 2.5L11 17.54V18a2 2 0 002 2v1a1 1 0 002 0v-1a2 2 0 002-2v-.46l1.66-1.11a3 3 0 001.34-2.5V9a3 3 0 00-3-3zm-1 5h2v1h-1a1 1 0 000 2h1a1 1 0 01-.44.76l-2.1 1.41A1 1 0 0015 17v1h-2v-1a1 1 0 00-.45-.83l-2.1-1.41a1 1 0 01-.45-.83V9a1 1 0 011-1h6a1 1 0 011 1h-2a1 1 0 000 2z"}})])
          )
        }
      }
    